import * as React from 'react'
import { IconsModel } from './iconsModel'

function SvgPrivate(
	{
		color,
		width = 50,
		height = 50
	}: IconsModel
) {
	return (
		<svg width={width} height={height}>
			<defs>
				<filter id="private_svg__a">
					<feColorMatrix
						in="SourceGraphic"
						values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
					/>
				</filter>
			</defs>
			<g>
				<g fill={color}>
					<path
						d="M13.076 14.82a1.64 1.64 0 00-1.639-1.638 1.64 1.64 0 00-1.638 1.639 1.64 1.64 0 001.639 1.638 1.64 1.64 0 001.638-1.638m13.986-.001a1.64 1.64 0 00-1.638-1.638 1.64 1.64 0 00-1.638 1.639 1.64 1.64 0 001.638 1.638 1.64 1.64 0 001.638-1.638" />
					<path
						d="M5.266 10.158a1.51 1.51 0 011.51-1.508h23.31c.832 0 1.51.676 1.51 1.508v8.16h1.644v-8.16a3.157 3.157 0 00-3.154-3.153H6.776a3.156 3.156 0 00-3.154 3.153v8.16h1.644v-8.16M29.743 35.8V24.146a1.51 1.51 0 011.509-1.509h3.147v-1.644h-3.147a3.156 3.156 0 00-3.153 3.153v3.84H7.119v7.816h1.644V29.63h19.336v6.17h1.644" />
					<path
						d="M35.092 36.998c0 .403-.157.782-.443 1.067a1.497 1.497 0 01-1.066.442h-.001l-30.305-.03a1.51 1.51 0 01-1.507-1.508V24.145a1.51 1.51 0 011.508-1.509H5.61a1.51 1.51 0 011.508 1.51v1.165h1.645v-1.166a3.157 3.157 0 00-3.153-3.153H3.278a3.157 3.157 0 00-3.153 3.153V36.97a3.157 3.157 0 003.15 3.153l3.843.004v2.699h1.645v-2.698l19.336.02v2.678h1.644v-2.677l3.837.003h.003c.842 0 1.633-.327 2.229-.922a3.135 3.135 0 00.925-2.231v-8.19h-1.645v8.19m4.319 5.801h6.993v-1.644h-6.993zm-3.497-18.312v1.645h6.171v13.164h1.645V26.133h6.171v-1.645H35.914m9.384-1.852l1.904-7.616-1.596-.399-1.592 6.371h-2.213l-1.592-6.371-1.596.399 1.904 7.616h4.781" />
				</g>
			</g>
		</svg>
	)
}

export default SvgPrivate
